import { Subscription, interval } from 'rxjs';
import {
  AfterContentInit,
  Directive,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormEventService } from '@hub/services/form-event.service';
import { switchMap, mergeMap, takeUntil, take } from 'rxjs/operators';
@Directive({
  selector: '[formEvent]'
})
export class FormEventDirective implements OnInit, OnDestroy, AfterContentInit {
  constructor(
    private el: ElementRef,
    private formEventService: FormEventService
  ) { }

  private tabFocusSub: Subscription;
  private focusOutSub: Subscription;

  ngOnInit() {
    let focusOut$ = this.formEventService.getFocusOut();
    let focusIn$ = this.formEventService.getFocusIn();

    this.focusOutSub = focusOut$
      .pipe(switchMap(() =>
        interval(100).pipe(
          take(1),
          takeUntil(focusIn$),
          mergeMap(val => interval(100).pipe(take(1))))
      ))
      .subscribe(val => {
        this.formEventService.changeFocus('-2');
      });

    this.tabFocusSub = this.formEventService.getTabFocus().subscribe(x => {
      this.formEventService.setFocusIn(true);
      let element: HTMLElement = this.el.nativeElement;
      let inp: any = element.querySelector('[tabindex="' + x + '"]');
      inp.focus();
    });
  }

  ngOnDestroy() {
    this.tabFocusSub.unsubscribe();
    this.focusOutSub.unsubscribe();
  }
  ngAfterContentInit() {
    let element: HTMLElement = this.el.nativeElement;
    let els: NodeListOf<any> = element.querySelectorAll('[tabindex]');
    let indexes: number[] = [];
    for (let i = 0; i < els.length; i++) {
      if (els[i].tabIndex > 0) {
        indexes.push(els[i].tabIndex);
      }
    }
    this.formEventService.setIndexNums(indexes);
  }

  @HostListener('keydown.Tab', ['$event'])
  handleTab(event: any) {
    this.formEventService.changeFocus(event.target.tabIndex);
  }
  @HostListener('document:click', ['$event'])
  handleClick(event: any) {

    if (event.target.tabIndex === -1 || event.target.tabIndex === 0) {
      this.formEventService.setFocusOut(true);
    }
    if (event.target.tabIndex > 0) {
      this.formEventService.setFocusIn(true);
    }
  }
}
